export var PlaybackState;
(function (PlaybackState) {
    PlaybackState["STOPPED"] = "STOPPED";
    PlaybackState["BUFFERING"] = "BUFFERING";
    PlaybackState["PAUSED"] = "PAUSED";
    PlaybackState["PLAYING"] = "PLAYING";
})(PlaybackState || (PlaybackState = {}));
